import {
  GET_AGE_VERIFICATION_STATUS,
  GET_ONDATA_URL_START,
  GET_WIZARD_PROFILES_URL,
  GET_WIZARD_URL,
  POST_REG_FUNNEL_ABOUT,
  POST_REG_FUNNEL_FINISH,
  POST_REG_FUNNEL_PREFERENCES,
  POST_REG_FUNNEL_START,
  POST_REG_FUNNEL_URL,
  POST_WIZARD_ABOUT_URL,
  POST_WIZARD_FINISH_URL,
  POST_WIZARD_PREFERENCES_URL,
  POST_WIZARD_START_URL,
  RANDOM_MSG_SEND_URL,
} from "shared/constants/apiUrls";

import { get, post } from "./axios-simple";

/**
 * Get post reg funnel data from api
 * @return {AxiosPromise<any>}
 */
export const getPostRegFunnelData = () => {
  return get(import.meta.env.VITE_APP_API_HOST + POST_REG_FUNNEL_URL);
};

/**
 * Get post started quiz
 * @return {AxiosPromise<any>}
 * @param {{data}} data step block
 */
export const getStartedQuiz = (data) => {
  return post(import.meta.env.VITE_APP_API_HOST + POST_REG_FUNNEL_START, data);
};

/**
 *  Post user preferences
 * @return {AxiosPromise<any>}
 * @param {{data}} data step block
 */
export const postUserPreferences = (data) => {
  return post(
    import.meta.env.VITE_APP_API_HOST + POST_REG_FUNNEL_PREFERENCES,
    data
  );
};

/**
 *  Post user preferences
 * @return {AxiosPromise<any>}
 * @param {{data}} data step block
 */
export const postUserInfoAbout = (data) => {
  return post(import.meta.env.VITE_APP_API_HOST + POST_REG_FUNNEL_ABOUT, data);
};

/**
 * Get countries list
 * @returns {AxiosPromise<any>}
 */
export const getChatRandom = () => {
  return get("/assets-v2/chat_random_v2.json");
  //return get(import.meta.env.VITE_APP_API_HOST + LOCATION_COUNTRIES);
};

/**
 * Post random chat text
 * @returns {AxiosPromise<any>}
 * @param {{data}} data step block
 */
export const postRandomChat = (data) => {
  return post(import.meta.env.VITE_APP_API_HOST + RANDOM_MSG_SEND_URL, data);
};

/**
 * Post Reg Funnel Finish
 * @returns {AxiosPromise<any>}
 */
export const postRegFunnelFinish = () => {
  return post(import.meta.env.VITE_APP_API_HOST + POST_REG_FUNNEL_FINISH);
};

/**
 * Get wizard
 * @returns {AxiosPromise<any>}
 */
export const getWizard = () => {
  return get(import.meta.env.VITE_APP_API_HOST + GET_WIZARD_URL);
};

/**
 * Get wizard profiles
 * @returns {AxiosPromise<any>}
 */
export const getWizardProfiles = () => {
  return get(import.meta.env.VITE_APP_API_HOST + GET_WIZARD_PROFILES_URL);
};

/**
 * Post wizard start
 * @returns {AxiosPromise<any>}
 * @param  {data} data step block
 */
export const postWizardStart = (data) => {
  return post(import.meta.env.VITE_APP_API_HOST + POST_WIZARD_START_URL, data);
};

/**
 * Post wizard preferences
 * @returns {AxiosPromise<any>}
 * @param  {data} data step block
 */
export const postWizardPrefences = (data) => {
  return post(
    import.meta.env.VITE_APP_API_HOST + POST_WIZARD_PREFERENCES_URL,
    data
  );
};

/**
 * Post wizard about
 * @returns {AxiosPromise<any>}
 * @param  {data} data step block
 */
export const postWizardAbout = (data) => {
  return post(import.meta.env.VITE_APP_API_HOST + POST_WIZARD_ABOUT_URL, data);
};

/**
 * Post wizard finish
 * @returns {AxiosPromise<any>}
 */
export const postWizardFinish = () => {
  return post(import.meta.env.VITE_APP_API_HOST + POST_WIZARD_FINISH_URL);
};

/**
 * Get user age verification status
 * @returns {AxiosPromise<any>}
 */
export const getUserAgeVerificationStatus = () => {
  return get(import.meta.env.VITE_APP_API_HOST + GET_AGE_VERIFICATION_STATUS);
};

/**
 * Get user age verification link
 * @returns {AxiosPromise<any>}
 */
export const getUserAgeVerificationLink = () => {
  return get(import.meta.env.VITE_APP_API_HOST + GET_ONDATA_URL_START);
};
